import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export default function InsightDetailPage() {
  const { slug } = useParams();
  const [article, setArticle] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`${API_URL}/api/insights/${slug}`)
      .then(res => {
        if (!res.ok) throw new Error('Not found');
        return res.json();
      })
      .then(data => { setArticle(data); setLoading(false); })
      .catch(() => setLoading(false));
  }, [slug]);

  if (loading) {
    return (
      <div className="min-h-screen bg-white pt-20 md:pt-36 pb-16 px-5 md:px-6 lg:px-8">
        <p className="text-center text-gray-500">loading...</p>
      </div>
    );
  }

  if (!article) {
    return (
      <div className="min-h-screen bg-white pt-20 md:pt-36 pb-16 px-5 md:px-6 lg:px-8">
        <div className="max-w-3xl mx-auto text-center">
          <h1 className="text-3xl font-light text-black mb-4">article not found</h1>
          <Link to="/insights" className="inline-block bg-black text-white px-4 py-1.5 rounded-full text-sm font-bold">
            back to insights
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-white pt-20 md:pt-36 pb-16 md:pb-24 px-5 md:px-6 lg:px-8">
      <article className="max-w-3xl mx-auto">
        <Link
          to="/insights"
          className="inline-block bg-black text-white px-4 py-1.5 rounded-full text-sm font-bold mb-6 md:mb-8 hover:bg-black/90 transition-colors"
          data-testid="back-to-insights"
        >
          back to insights
        </Link>

        <p className="text-sm text-gray-500 mb-4">{article.date}</p>
        <h1 className="text-2xl md:text-4xl lg:text-5xl font-light tracking-tight text-black mb-6 md:mb-8 leading-tight">
          {article.title}
        </h1>

        <div className="text-base md:text-lg text-gray-700 leading-relaxed space-y-6">
          {article.content.split('\n\n').map((paragraph, i) => (
            <p key={i}>{paragraph}</p>
          ))}
        </div>
      </article>
    </div>
  );
}
